<template>
    <div class="container container-tabs">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane name="all" class="to-searh">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>
            <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>

            <div>
                <el-button type="primary" @click="add_isShow = !add_isShow">添加</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            </div>
        </el-tabs>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="创建详细时间">
                            <span>{{ props.row.time.YmdHis }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="id" min-width="80"> </el-table-column>
            <el-table-column prop="title" label="优惠名称" min-width="180"> </el-table-column>
            <el-table-column prop="full_month" label="优惠条件（月）"> </el-table-column>
            <el-table-column prop="amount" label="金额（元）"> </el-table-column>
            <el-table-column prop="city.name" label="城市信息"> </el-table-column>
            <el-table-column prop="admin_name" label="创建人"> </el-table-column>
            <el-table-column prop="type.alias" label="参与用户"> </el-table-column>
            <el-table-column prop="time.Ymd" label="创建时间"> </el-table-column>
            <el-table-column label="管理状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}</el-tag
                    >
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-dropdown split-button trigger="click" type="primary" @click="editPage(scope.row)">
                        编辑

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="del(scope.row.driver_signing_month_preferential_code)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
        <!-- 添加组件 -->
        <addSigningMonthPreferential :isShow="add_isShow" @onSubmit="signingMonthPreferentialLists"></addSigningMonthPreferential>

        <!-- 编辑组件 -->
        <editSigningMonthPreferential
            :isShow="edit_isShow"
            :data="driver_signing_month_preferential_code"
            @onSubmit="signingMonthPreferentialLists"
        >
        </editSigningMonthPreferential>
    </div>
</template>
<script>
var _this;
import addSigningMonthPreferential from './addSigningMonthPreferential.vue';
import editSigningMonthPreferential from './editSigningMonthPreferential.vue';
export default {
    components: {
        addSigningMonthPreferential,
        editSigningMonthPreferential
    },
    data() {
        return {
            driver_signing_month_preferential_code: '',
            add_isShow: false,
            edit_isShow: false,
            // 选项卡默认选中项
            activeName: 'all',

            // 存放表格数据
            tableData: [],

            // 分页需要的数据
            result_data: [],

            // 获取标签的数组
            value_status_array: [],

            search_data: {
                page: 1,
                limit: 10,
                status: ''
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.signingMonthPreferentialLists();
    },
    methods: {
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.signingMonthPreferentialLists();
        },
        editPage(val) {
            
            console.log(val,'val');
            _this.edit_isShow = !_this.edit_isShow;
            _this.driver_signing_month_preferential_code = val.driver_signing_month_preferential_code;
            console.log(_this.driver_signing_month_preferential_code,'console.log(_this.driver_signing_month_preferential_code);');
        },
        del(code) {
            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/driver/deleteSigningMonthPreferentialSubmit', {
                            driver_signing_month_preferential_code: code
                        })
                        .then((res) => {
                            _this.signingMonthPreferentialLists();

                            _this.$message.success(res.msg);
                        })
                        .catch((err) => {});
                })
                .catch(() => {});
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },
        // 获取列表数据
        signingMonthPreferentialLists() {
            _this.$post('/driver/signingMonthPreferentialLists', _this.search_data, _this.search_rules).then((res) => {
                _this.tableData = res.data;
                _this.result_data = res;
                _this.value_status_array = _this.tableData[0].status.select_array;
            });
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.status = tab.name;
        } else {
          _this.search_data.status = '';
        }
        _this.search_data.page = 1;
        _this.signingMonthPreferentialLists();
        }
    }
};
</script>